module.exports = __webpack_public_path__ + "img/021-cook-islands.c4624260.svg";